<div class="flex-container signup-saudia">
  <div class="container">
    <section class="signup-form-cont">
      <div class="twoColLayout main-content" *ngIf="!fetchMatchS">
        <div class="registerForm-title-section col">
          <h2 class="title">
            {{content?.['b2b.managetraveler.efcompleteprofile']}}
          </h2>
        </div>

        <form class="form-new">
          <!-- Corporate Information -->
          <div class="f-col">
            <app-admin-info
              (existEmail)="fetchMatchStatus($event)"
            ></app-admin-info>
          </div>
        </form>
      </div>

      <div *ngIf="fetchMatchS">
        <app-stop-onboarding [email]="matchedEmail"></app-stop-onboarding>
      </div>
    </section>
  </div>
</div>
